export default "__VITE_ASSET__D$0uHcwy__"